import { inject, injectable } from "@launchtray/tsyringe-async";
import { ICanvasScaler } from "../../../../../canvas/ICanvasScaler";
import { Viewable } from "../../../../../scene/viewable/Viewable";
import { CommonResourcesPackage } from "../../../common/resources/CommonResourcesPackage";
import { PromiseCompletionSource } from "../../../../../shared/async/PromiseCompletionSource";
import { IAnalyticProviderWrapper } from "../../../../../analytics/IAnalyticProviderWrapper";
import { SoundsResourcePackageWrapper } from "../../../common/resources/SoundsResourcePackageWrapper";
import { HourlyBonusPopupView } from "./view/HourlyBonusPopupView";
import { HourlyBonusResourcePackage } from "./resources/HourlyBonusResourcePackage";
import { IFortuneWheelModel } from "../model/IFortuneWheelModel";
import { IFortuneWheelController } from "./controller/IFortuneWheelController";
import { TopPanel } from "../../../game/components/toppanel/TopPanel";
import { IPlayerModel } from "../../../common/models/IPlayerModel";
import { ILogger } from "by/gamefactory/cityversetycoon/logger/ILogger";
import { HourlyBonusState } from "./HourlyBonusState";
import { CancellationToken } from "../../../../../shared/async/CancellationToken";

export type HourlyBonusSceneOptions = {
    state: HourlyBonusState;
    cancellationToken: CancellationToken;
}

@injectable()
export class HourlyBonusPopupScene extends Viewable<void> {
    public constructor(
        commonResources: CommonResourcesPackage,
        wheelResources: HourlyBonusResourcePackage,
        soundResources: SoundsResourcePackageWrapper,
        @inject("IPlayerModel") playerModel: IPlayerModel,
        @inject("ICanvasScaler") canvasScaler: ICanvasScaler,
        @inject("IAnalyticProviderWrapper") analyticsProvider: IAnalyticProviderWrapper,
        @inject("IFortuneWheelModel") fortuneWheelModel: IFortuneWheelModel,
        @inject("IFortuneWheelController") fortuneWheelController: IFortuneWheelController,
        @inject("HourlyBonusSceneOptions") options: HourlyBonusSceneOptions,
        topPanel: TopPanel,
        @inject("ILogger") logger: ILogger
    ) {
        super();
        const pcs = new PromiseCompletionSource<void>();
        this.view = new HourlyBonusPopupView(
            pcs,
            options.cancellationToken,
            commonResources,
            wheelResources,
            soundResources,
            playerModel,
            canvasScaler,
            analyticsProvider,
            fortuneWheelModel,
            fortuneWheelController,
            topPanel,
            options.state,
            logger
        );
        pcs.result.then(() => {
            this.operationControls.complete();
        }, (reason: unknown) => {
            this.operationControls.error(reason);
        });
    }
}
